// https://tarekraafat.github.io/autoComplete.js/#/configuration
// https://tarekraafat.github.io/autoComplete.js/#/how-to-guides?id=multiple-choices
import autoComplete from "@tarekraafat/autocomplete.js"

export default () => ({
  label: null,
  autocomplete: null,
  selected: [],
  open: false,
  isSearching: false,
  init(){
    if(this.autocomplete){
      // opt a => remove autocomplete instance (???)
      // opt b => keep configs, clear state and leave everything alone (easy)
      this.selected = []
      this.open = false
      this.isSearching = false
      return
    }

    const input = this.$root.querySelector('input[type=hidden]')
    this.label = this.$root.getAttribute('label') || 'Set the label attribute on the element tag!'

    // fill autocomplete options
    // https://github.com/alpinejs/alpine/blob/main/packages/alpinejs/src/evaluator.js#L61
    const optionsEvaluator = new Function(`return ${this.$el.getAttribute('options')}`)
    const options = {
      placeHolder: input.placeholder,
      data: {
        src: [],
        keys: []
      },
      ...optionsEvaluator()
    }

    this.$watch('selected', (newValue) => input.value = JSON.stringify(newValue))

    // set relative container
    this.$el.style.position = 'relative'
    // set main configs
    const configs = {
      ...options,
      selector: () => this.$refs.search, // force selector as search
      threshold: 0,
      data: {
        ...options.data,
        src: async (q) => {
          this.isSearching = true
          // run function for results or use static array
          const opts = typeof options.data.src === 'function' ?
                    (options.data.src.constructor.name === "AsyncFunction" ? await options.data.src(q) : options.data.src(q))
                    : options.data.src

          this.isSearching = false

          return opts//.filter(el => !this.selected.map(e => e.value).includes(el.value))
          // proxy array comparison
          // return opts.filter(el => !this.selected.map((e) => JSON.stringify(e)).includes(JSON.stringify(el)))
        },
        keys: ['value'],
      },
      wrapper: false,
      resultsList: {
        destination: () => this.$refs.listContainer,
        class: 'tag-selectable-list',
        position: 'afterbegin'
      },
      resultItem: {
        selected: 'active',
        element: (item, data) => {
          this.selected.map(e => e.value).includes(data.value.value) ?
            item.classList.add('selected')
            : item.classList.remove('selected')
        }
      }
    }

    // init
    this.autocomplete = new autoComplete(configs)

    this.$el.addEventListener('selection', (e) => {
      const selection = e.detail.selection.value
      this.onClick(selection)
    })

    this.$el.addEventListener('close', (e) => {
      if(e.detail.selection){
        const selectedIndex = e.detail.selection.index
        // exited after selection
        // this.autocomplete.open()
        const search = this.autocomplete.input
        this.autocomplete.start(search.value)
        this.$nextTick(() => this.autocomplete.goTo(selectedIndex))
      }
    })
  },
  onOpen(){
    this.open = true
    const search = this.autocomplete.input
    this.autocomplete.start(search.value)
    this.$nextTick(() =>  search.focus())
  },
  onClose(){
    const search = this.autocomplete.input
    search.value = ''
    this.open = false
  },
  onClick(item){
    if(this.selected.find(el => el.value == item.value)) return this.onRemove(item)

    this.selected.push(item)
    // const search = this.autocomplete.input
    // search.value = ''
    // search.focus()
    this.hasChanged()
  },
  onRemove(item){
    this.selected = this.selected.filter(el => el.value != item.value)
    this.hasChanged()
  },
  onClear(){
    this.selected = []
    const search = this.autocomplete.input
    this.autocomplete.start(search.value)
    this.hasChanged()
  },
  hasChanged(){
    const input = this.$root.querySelector('input[type=hidden]')
    this.$nextTick(() => input.dispatchEvent(new Event('change')))
    // this.onClose()
  },
})